import React from 'react';
import { RubigramStore } from '../RubigramStore';

type ControlSubgridProps = {
  subgridId: number;
};

const SolvedSubgrid = ({ subgridId }: ControlSubgridProps) => {
  const subgrid = RubigramStore.useState(s => s.subgrids[subgridId]);

  return (
    <div className={`controlSubgrid subgrid${subgridId}`}>
      <div className="controlSubgridFlipper">

        <div className="controlSubgridContents">
          {subgrid.solvedContent.map((row, rowIndex) => (
            <div key={rowIndex} className="gridRow">
              {row.map((cell, cellIndex) => (
                <div key={cellIndex} className="gridCellContainer">
                  <div className="gridCell">
                    {cell}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default SolvedSubgrid;